import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpApiService } from '@recruitee/http';
import {
  PaginationMeta,
  Referrer,
  tableDataDefaultParams,
  TableDataParams,
} from '@recruitee/http-types';

@Injectable({ providedIn: 'root' })
export class ReferrersHttpClient {
  constructor(private httpApi: HttpApiService) {}

  public loadReferrers(
    params: Partial<TableDataParams>,
  ): Observable<{ rows: Referrer[]; meta: PaginationMeta }> {
    return this.httpApi.get(`/referral/referrers`, { ...tableDataDefaultParams, ...params }).pipe(
      map((data: { meta: PaginationMeta; referrers: Referrer[] }) => ({
        meta: data.meta,
        rows: data.referrers,
      })),
    );
  }

  public deleteReferrers(ids: number[]): Observable<void> {
    return this.httpApi.post(
      '/referral/referrers/delete_all',
      {},
      {
        referrers_ids: ids,
      },
    );
  }

  public inviteReferrers(
    emails: string[],
    message: string | null,
  ): Observable<{ emailsSent: string[] }> {
    return this.httpApi.post(`/referral/program/send_invitations`, null, {
      emails,
      message,
    });
  }
}
